var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.return_object
        ? _c("v-combobox", {
            class: { dense_input: _vm.dense },
            attrs: {
              rules: _vm.rules,
              readonly: _vm.readonly,
              multiple: _vm.multiple,
              value: _vm.value,
              hint: _vm.hint,
              "hide-details": _vm.hide_details,
              loading: _vm.loading,
              items: _vm.items,
              solo: _vm.solo,
              "item-text": "email",
              "item-value": "id",
              "hide-selected": "",
              "append-icon": "",
              "no-filter": "",
              dense: "",
              "small-chips": "",
              "deletable-chips": "",
              "auto-select-first": true,
              "search-input": _vm.search
            },
            on: {
              "update:searchInput": function($event) {
                _vm.search = $event
              },
              "update:search-input": function($event) {
                _vm.search = $event
              },
              change: function($event) {
                return _vm.onChange($event)
              }
            },
            nativeOn: {
              paste: function($event) {
                return _vm.onPaste($event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm._f("maestroParamLabel")(_vm.param)) +
                          "\n\t\t"
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2336691890
            )
          })
        : _c("v-combobox", {
            class: { dense_input: _vm.dense },
            attrs: {
              rules: _vm.rules,
              readonly: _vm.readonly,
              multiple: _vm.multiple,
              value: _vm.value,
              hint: _vm.hint,
              "hide-details": _vm.hide_details,
              loading: _vm.loading,
              items: _vm.items,
              solo: _vm.solo,
              "hide-selected": "",
              "append-icon": "",
              "no-filter": "",
              dense: "",
              "small-chips": "",
              "deletable-chips": "",
              "auto-select-first": true,
              "search-input": _vm.search
            },
            on: {
              "update:searchInput": function($event) {
                _vm.search = $event
              },
              "update:search-input": function($event) {
                _vm.search = $event
              },
              change: function($event) {
                return _vm.onChange($event)
              }
            },
            nativeOn: {
              paste: function($event) {
                return _vm.onPaste($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function() {
                  return [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm._f("maestroParamLabel")(_vm.param)) +
                        "\n\t\t"
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46adceb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46adceb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/field_email.vue
// module id = null
// module chunks = 